import { render, staticRenderFns } from "./load-24.vue?vue&type=template&id=a06157be&scoped=true"
import script from "./load-24.vue?vue&type=script&lang=js"
export * from "./load-24.vue?vue&type=script&lang=js"
import style0 from "./load-24.vue?vue&type=style&index=0&id=a06157be&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06157be",
  null
  
)

export default component.exports